import Checkbox from "components/Cards/Card/Actions/Checkbox"

import { ComponentProps } from "."

const IsSingleSource = ({ checked, isDisabled, onChange }: ComponentProps) => (
  <Checkbox
    checked={checked}
    disabled={isDisabled}
    inputId="isSingleSource"
    label="Single Source"
    name="isSingleSource"
    onChange={onChange}
  />
)

export default IsSingleSource
